// export type UserStatus =
//   | "UNCONFIRMED"
//   | "CONFIRMED"
//   | "EXTERNAL_PROVIDER"
//   | "UNKNOWN"
//   | "RESET_REQUIRED"
//   | "FORCE_CHANGE_PASSWORD";

// type UserStatusLabeled = {
//   label: string;
//   description: string;
// };

// export const formatUserStatus = (status: string): UserStatusLabeled => {
//   const userStatuses: Record<UserStatus, UserStatusLabeled> = {
//     UNCONFIRMED: {
//       label: "Unconfirmed",
//       description: "User has been created but not confirmed.",
//     },
//     CONFIRMED: {
//       label: "Confirmed",
//       description: "User has been confirmed.",
//     },
//     EXTERNAL_PROVIDER: {
//       label: "External Provider",
//       description: "User signed in with a third-party IdP.",
//     },
//     UNKNOWN: {
//       label: "Unknown",
//       description: "User status isn't known.",
//     },
//     RESET_REQUIRED: {
//       label: "Reset Required",
//       description:
//         "User is confirmed, but the user must request a code and reset their password before they can sign in.",
//     },
//     FORCE_CHANGE_PASSWORD: {
//       label: "Force Change Password",
//       description:
//         "The user is confirmed and can sign in using a temporary password. On first sign-in, the user must change their password to a new value before doing anything else.",
//     },
//   };

//   return (
//     userStatuses[status as UserStatus] ?? {
//       label: status,
//       description: status,
//     }
//   );
// };

import type { GetUserResponse } from "@shared/apis/sidekick/generated";

export const isSsoOnlyUser = (
  user: Pick<GetUserResponse, "initialLoginMethod">,
): boolean => {
  return (user.initialLoginMethod as unknown) === "sso";
};

interface Column {
  id: string;
  label: string;
  minWidth?: number;
  maxWidth?: number;
  align?: "center" | "left" | "right" | "inherit" | "justify";
  formatString?: (value: string) => string;
}

export const usersTableColumns: readonly Column[] = [
  { id: "id", label: "ID" },
  { id: "name", label: "Name", minWidth: 200 },
  { id: "email", label: "E-mail", minWidth: 200 },
  {
    id: "actions",
    label: "Actions",
    align: "center",
  },
];
